import AccountingStatisticsCard from "../../components/Accounting/AccountingStatisticsCard/AccountingStatisticsCard";

const AccountingHomePage = () => {
  return <AccountingStatisticsCard />;
};

export default AccountingHomePage;

